import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getShows } from '../Redux/Actions/actions';
import Swal from 'sweetalert2';
import { jsPDF } from "jspdf";

const MisCompras = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state?.user);
  const shows = useSelector((state) => state.shows);

  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTicket, setSelectedTicket] = useState(null);

  // 🔥 NUEVO (NO afecta UI)
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('default');

  const ticketsPerPage = 6;

  const getDateObj = (ticket) => {
    const parts = ticket.date.split(" || ");
    const date = parts[0];
    const time = parts[1]?.split(" - ")[1];
    return new Date(`${date}T${time}:00`);
  };

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        let userTickets = [];

        const response = await axios.get('/tickets');

        if (response.data?.tickets) {
          if (user?.cashier || user?.isAdmin) {
            userTickets = [];
          } else {
            userTickets = response.data.tickets
              .filter(ticket => ticket.userId === user?.id && ticket.state === true)
              .filter(ticket => ticket.price > 0);
          }
        }

        setTickets(userTickets);

        if (userTickets.length === 0) {
          Swal.fire({
            title: '¡No tienes compras!',
            text: 'No tienes tickets registrados. ¿Quieres ir a tu perfil?',
            icon: 'info',
            confirmButtonText: 'Aceptar',
          }).then((result) => {
            if (result.isConfirmed) navigate('/profile');
          });
        }

      } catch {
        setError('Error al obtener los tickets.');
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchTickets();
      dispatch(getShows());
    }
  }, [user, dispatch, navigate]);

  useEffect(() => {
    document.body.style.overflow = selectedTicket ? 'hidden' : 'auto';
  }, [selectedTicket]);

  const currentDateTime = new Date();

  // 🔥 PROCESADO PRO (SIN TOCAR UI)
  const processedTickets = useMemo(() => {
    let result = [...tickets];

    // 🔎 BUSCADOR
    result = result.filter(ticket => {
  if (!ticket) return false;

  const showName =
    shows.find(show => show.id === ticket.showId)?.name || "";

  return showName.toLowerCase().includes(search.toLowerCase());
});

    // 🔽 FILTROS
    if (filter === 'activos') {
      result = result.filter(t => getDateObj(t) > currentDateTime);
    }

    if (filter === 'inactivos') {
      result = result.filter(t => getDateObj(t) < currentDateTime);
    }

    // 🔥 ORDEN
    result.sort((a, b) => {
      const dateA = getDateObj(a);
      const dateB = getDateObj(b);

      const isPastA = dateA < currentDateTime;
      const isPastB = dateB < currentDateTime;

      if (filter === 'antiguos') return dateA - dateB;
      if (filter === 'recientes') return dateB - dateA;

      // default PRO
      if (isPastA !== isPastB) return isPastA - isPastB;
      return dateA - dateB;
    });

    return result;
  }, [tickets, search, filter, shows]);

  const totalPages = Math.ceil(processedTickets.length / ticketsPerPage);

  const startIndex = (currentPage - 1) * ticketsPerPage;
  const endIndex = startIndex + ticketsPerPage;
  const currentTickets = processedTickets.slice(startIndex, endIndex);

const downloadTicketPDF = (ticket) => {
  const doc = new jsPDF();
  const finalPrice = ticket.chargePrice ?? ticket.price;
  const showName =
    shows.find(show => show.id === ticket.showId)?.name ||
    "Show desconocido";

  const dateTimeParts = ticket.date.split(" || ");
  const eventDate = dateTimeParts[0];
  const eventTime = dateTimeParts[1]?.split(" - ")[1];

  // 🔷 HEADER
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  // doc.text("ENTRADA OFICIAL", 105, 20, { align: "center" });

  // línea separadora
  doc.setLineWidth(0.5);
  doc.line(20, 25, 190, 25);

  // 🔷 CONTENIDO
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.text(`Ticket N°${ticket.id}`, 20, 30);
  doc.text(`Usuario: ${ticket.name}`, 20, 40);
  doc.text(`Evento: ${showName}`, 20, 50);
  doc.text(`Fecha: ${eventDate}`, 20, 60);
  doc.text(`Hora: ${eventTime}`, 20, 70);
  doc.text(`Zona: ${ticket.division}`, 20, 80);

  if (ticket.row && ticket.seat) {
    doc.text(`Fila: ${ticket.row}`, 20, 90);
    doc.text(`Asiento: ${ticket.seat}`, 20, 100);
  } else {
    doc.text(`Fila: General`, 20, 90);
    doc.text(`Asiento: General`, 20, 100);
  }

  if (ticket.price) {
    doc.text(`Precio: ${finalPrice.toFixed(2) || "No disponible"}`, 20, 110);
  }

  // 🔷 QR ABAJO CENTRADO
  if (ticket.qrCode) {
    const qrSize = 60;
    const pageWidth = doc.internal.pageSize.getWidth();
    const x = (pageWidth - qrSize) / 2;

    doc.addImage(ticket.qrCode, "PNG", x, 130, qrSize, qrSize);
  }

  // 🔷 FOOTER PROFESIONAL
  doc.setFontSize(10);
  doc.setFont("helvetica", "italic");
  doc.text(
    "Gracias por su compra. Conserve esta entrada para el acceso al evento.",
    105,
    200,
    { align: "center", maxWidth: 170 }
  );

  doc.save(`Ticket_${ticket.id}.pdf`);
};

  if (loading) return <div className="loading">Cargando tus compras...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="mt-[160px] min-h-screen p-4 bg-gradient-to-b from-[rgba(27, 27, 235, 0.78)] to-[rgba(33, 33, 221, 0.4)] backdrop-blur-md">
      <div className="max-w-6xl mx-auto text-white">

        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6">Mis Compras</h2>

        {/* 🔥 BUSCADOR + FILTRO (simple, no rompe diseño) */}
        <div className="flex flex-wrap justify-center gap-4 mb-6">
          <input
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            placeholder="Buscar evento..."
            className="p-2 rounded text-black"
          />

          <select
            value={filter}
            onChange={(e) => {
              setFilter(e.target.value);
              setCurrentPage(1);
            }}
            className="p-2 rounded text-black"
          >
            <option value="default">Orden inteligente</option>
            <option value="recientes">Más recientes</option>
            <option value="antiguos">Más antiguos</option>
            <option value="activos">Activos</option>
            <option value="inactivos">Inactivos</option>
          </select>
        </div>

        {/* 🔥 GRID ORIGINAL intacto */}
        <div className="flex justify-center">
          <ul className="grid gap-6 sm:grid-cols-3">
            {currentTickets.map(ticket => {
              const showName = shows.find(show => show.id === ticket.showId)?.name || "Show desconocido";
              const finalPrice = ticket.chargePrice ?? ticket.price;
              return (
                <li
                  key={ticket.id}
                  onClick={() => setSelectedTicket(ticket)}
                  className="bg-[#0C2342] backdrop-blur-md rounded-lg p-4 shadow-md flex flex-col gap-1 max-w-sm cursor-pointer"
                >
                  <p><strong>Evento:</strong> {showName}</p>
                  <p><strong>Fecha y Hora:</strong> {ticket.date}</p>
                  <div className="text-right mt-2">⬇</div>
                  <div className="text-right mt-2">Expandir</div>
                </li>
              );
            })}
          </ul>
        </div>

        {/* 🔥 TU MODAL ORIGINAL (intacto) */}
        {selectedTicket && (
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black/40" onClick={() => setSelectedTicket(null)} />

            <div className="relative bg-[#0C2342] text-white backdrop-blur-md rounded-lg p-6 shadow-md flex flex-col gap-1 max-w-sm w-[90%] z-50">

              <div className="flex justify-end">
                <button onClick={() => setSelectedTicket(null)}>⬆</button>
              </div>

              {(() => {
                const showName = shows.find(show => show.id === selectedTicket.showId)?.name || "Show desconocido";
                const dateTimeParts = selectedTicket.date.split(" || ");
                const eventDateStr = dateTimeParts[0];
                const eventTimeStr = dateTimeParts[1]?.split(" - ")[1];
                const eventDateTime = new Date(`${eventDateStr}T${eventTimeStr}:00`);
                const isPastEvent = eventDateTime < currentDateTime;
                const finalPrice =
                selectedTicket?.chargePrice ?? selectedTicket?.price ?? 0;

                return (
                  <>
                    <p><strong>Ticket N°</strong> {selectedTicket.id}</p>
                    <p><strong>Usuario:</strong> {selectedTicket.name}</p>
                    <p><strong>Evento:</strong> {showName}</p>
                    <p><strong>Zona:</strong> {selectedTicket.division}</p>
                    <p><strong>Fecha y Hora:</strong> {selectedTicket.date}</p>
                    
                    {selectedTicket.row && selectedTicket.seat ? (
                      <>
                        <p><strong>Fila:</strong> {selectedTicket.row}</p>
                        <p><strong>Asiento:</strong> {selectedTicket.seat}</p>
                      </>
                    ) : (
                      <>
                        <p><strong>Fila:</strong> No corresponde</p>
                        <p><strong>Asiento:</strong> No corresponde</p>
                      </>
                    )}

                    <p className='font-bold text-white'><strong>Precio:</strong><br />${finalPrice.toFixed(2)}</p>

                    <p className={`font-bold ${isPastEvent ? "text-red-400" : "text-green-400"}`}>
                      {isPastEvent ? "Evento Finalizado" : "Evento Activo"}
                    </p>

                    {selectedTicket.qrCode && (
                      <img src={selectedTicket.qrCode} alt="QR" className="w-32 mt-2" />
                    )}

                    <button
                      onClick={() => downloadTicketPDF(selectedTicket)}
                      className="secondary text-white px-4 py-2 rounded mt-2"
                    >
                      Descargar Entrada
                    </button>
                  </>
                );
              })()}
            </div>
          </div>
        )}

        {/* 🔥 PAGINACIÓN ORIGINAL + mejoras */}
        <div className="flex items-center justify-center gap-4 mt-8 flex-wrap">

          <button
            className="secondary text-white px-3 py-1 rounded"
            onClick={() => setCurrentPage(1)}
          >
            Primera
          </button>

          <button
            className="secondary text-white px-3 py-1 rounded"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(prev => prev - 1)}
          >
            Anterior
          </button>

          <span>Página {currentPage} de {totalPages}</span>

          <button
            className="secondary text-white px-3 py-1 rounded"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(prev => prev + 1)}
          >
            Siguiente
          </button>

          <button
            className="secondary text-white px-3 py-1 rounded"
            onClick={() => setCurrentPage(totalPages)}
          >
            Última
          </button>

          <input
            type="number"
            min="1"
            max={totalPages}
            placeholder="Ir a..."
            onChange={(e) => {
              const page = Number(e.target.value);
              if (page >= 1 && page <= totalPages) setCurrentPage(page);
            }}
            className="w-20 p-1 text-black rounded"
          />
        </div>

        {/* VOLVER */}
        <div className="flex justify-center mt-6">
          <button
            className="secondary text-white px-4 py-2 rounded"
            onClick={() => navigate('/profile')}
          >
            Regresar
          </button>
        </div>

      </div>
    </div>
  );
};

export default MisCompras;
